export default {
  'common.website.slogan': 'Win the future with ChainIDE',
  'common.website.tagline':
    'Empowering the future and building the decentralized world with a cloud-based multi-chain IDE'
};
